import { getPaymentMethodIcon } from '@systemeio/ui/icons'
import { Checkbox, PaymentMethodEnum, getPaymentMethodTitle } from '@systemeio/ui'
import React, { useEffect } from 'react'
import {
  FieldErrorAndDescription,
  FieldErrorAndDescriptionProps,
} from 'shared/components/form/field-error-and-description'
import { FieldLabel } from 'shared/components/form/field-label'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface PaymentMethodsProps extends FieldErrorAndDescriptionProps {
  value?: PaymentMethodEnum[]
  onChange: (value?: PaymentMethodEnum[]) => void
  data?: PaymentMethodEnum[]
  isPreFetching?: boolean
  required?: boolean
}

const PaymentMethods = ({
  value,
  onChange,
  data,
  isPreFetching,
  error,
  required,
}: PaymentMethodsProps) => {
  useEffect(() => {
    if (value && data) {
      const validItems = value.filter(item => data.includes(item))

      if (validItems.length !== value.length) {
        onChange(validItems)
      }
    }
  }, [value, data])

  const { t } = useLocoTranslation()
  return (
    <div className={`flex-col gap-1 text-sm font-medium`}>
      <div className={`flex-col gap-1 ${data && data.length === 0 ? 'hidden' : 'flex'}`}>
        <FieldLabel
          label={t('dashboard.payment_methods.allowed_payment_methods')}
          required={required}
        />
        <ul className={'flex flex-row flex-wrap gap-5'}>
          {isPreFetching || !data || !value ? (
            <PaymentMethodsSkeleton />
          ) : (
            data.map(el => {
              const isSelected = value.includes(el)
              return (
                <li key={el}>
                  <Checkbox
                    value={isSelected}
                    label={
                      <div
                        className={`flex items-center gap-1.5 [&>svg]:h-[20px] [&>svg]:w-[20px] ${
                          isSelected && '[&>svg]:fill-brand-primary [&>svg]:main-transition-colors'
                        }`}
                      >
                        {getPaymentMethodIcon(el)}
                        {getPaymentMethodTitle(el)}
                      </div>
                    }
                    onChange={() =>
                      isSelected
                        ? onChange(value.filter(method => method !== el))
                        : onChange([...value, el])
                    }
                  />
                </li>
              )
            })
          )}
        </ul>
      </div>
      <FieldErrorAndDescription error={error} />
    </div>
  )
}

const PaymentMethodsSkeleton = () => (
  <div className={'flex animate-pulse gap-7'}>
    <div className={'bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent'}>.</div>
    <div className={'bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent'}>.</div>
    <div className={'bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent'}>.</div>
    <div className={'bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent'}>.</div>
  </div>
)

export default PaymentMethods
